import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { IPost } from '../types';

interface IProps {
	posts: Array<IPost>;
}

const NoResults = ({ posts }: IProps) => {
	const { clearFilters } = useFiltersContext();

	if (!posts.length) {
		const handleOnClick = () => {
			if (clearFilters) {
				clearFilters();
			}
		};

		return (
			<div className="pfa-no-results">
				<h2 className="t4">No Results Found</h2>
				<button
					className="btn btn-primary btn-black pfa-no-results__clear"
					onClick={handleOnClick}
				>
					Clear Filters
				</button>
			</div>
		);
	}

	return <></>;
};

NoResults.displayName = 'NoResults';

export default NoResults;
